import React from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';

import {
  Container,
  BookingInfoHeader,
  BookingInfoDates,
  BookingInfoRooms,
  RoomLabel,
  RoomGuest,
  EditIcon,
  EditContainer,
  DateContainer,
  Date,
  RoomContainer,
} from './styles';

export interface Props {
  checkIn: Date;
  checkOut: Date;
  isEdit?: boolean;
  guestQuantity: number;
}

const BookingInfo = ({ checkIn, checkOut, isEdit, guestQuantity }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  return (
    <Container>
      <BookingInfoHeader>
        <BookingInfoDates>
          <DateContainer>
            {t('hotelBookingInfo.checkIn')}
            <Date>{moment(checkIn).utc().format('DD MMM')}</Date>
          </DateContainer>
          <DateContainer>
            {t('hotelBookingInfo.checkOut')}
            <Date>{moment(checkOut).utc().format('DD MMM')}</Date>
          </DateContainer>
        </BookingInfoDates>
        <BookingInfoRooms>
          <RoomContainer>
            <RoomLabel>{t('hotelBookingInfo.roomQuantity', { count: 1 })}</RoomLabel>
            <RoomGuest>{t('hotelBookingInfo.guestQuantity', { count: guestQuantity })}</RoomGuest>
          </RoomContainer>
        </BookingInfoRooms>
      </BookingInfoHeader>
      {isEdit && (
        <EditContainer>
          <EditIcon src="/corporate/images/edit-booking.svg" onClick={() => history.push('/corporate/booking/hotels')} />
        </EditContainer>
      )}
    </Container>
  );
};

export default BookingInfo;
